import JsonViewReact18 from 'react18-json-view'
import 'react18-json-view/src/style.css'

export default function JsonView(props) {
  return <JsonViewReact18 {...props} />;
}
